import api from '..';
import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';

export const useMenusList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'menus', api: api.menus }, queryVariables, queryConfig);

  return {
    menus: queryResult.resolvedData,
    ...queryResult,
  };
};

const createMutation = mutationFactory({ invalidate: 'menus' });

export const useUpdateMenu = createMutation(api.menus.update);
export const useCreateMenu = createMutation(api.menus.create);
export const useUpsertMenu = createMutation(api.menus.upsert);
export const useUpdateNavigationMenus = createMutation(api.menus.updateNavigationMenus);

